<template>
  <el-card class="flex-1 h-full hk-monitor-wrapper" :body-style="{ height: '100%' }">
    <div class="flex flex-col h-full">
      <TitleBorder title="实时监控画面"></TitleBorder>
      <!-- 海康 -->
      <div class="flex-1">
        <HKPlayer :cameraIndexCode="cameraIndexCode" id="hk-palyer" :showToolbar="1"></HKPlayer>
      </div>
    </div>
  </el-card>
</template>

<script>
import HKPlayer from '@/components/video/HKPlayer/index'
import TitleBorder from '@/components/TitleBorder'

export default {
  name: 'DHMonitor',
  components: {
    HKPlayer,
    TitleBorder
  },
  data() {
    return {
      currentWindow: 0,
      monitorNum: 1
    }
  },
  props: {
    cameraIndexCode: {
      type: String,
    },
  },
  methods: {
  }
}
</script>
